import React from 'react';

import { I18n } from '@aws-amplify/core';

import type { FrequencyCategory } from '@/types';

import * as S from '@/components/views/Report/KimLhc/Report/Steps/Result/styles';

interface FrequencyCategoryProps {
	data: FrequencyCategory;
}

export function FrequencyCategory({ data }: Readonly<FrequencyCategoryProps>): JSX.Element {
	return (
		<S.AccordionContent>
			<S.ContentText>
				{I18n.get('Up to')} {data.value} {I18n.get('times per activity and work shift')}
			</S.ContentText>
		</S.AccordionContent>
	);
}
